export const CITY_GEOGRAPHY = {
  name: 'New York City',
  constant: 'CITY',
  frontEndPath: 'city',
  queryName: 'city',
}

export const BOROUGH_GEOGRAPHY = {
  name: 'Borough',
  constant: 'BOROUGH',
  frontEndPath: 'borough',
  queryName: 'borough',
}

export const COUNCIL_GEOGRAPHY = {
  name: 'Council District',
  constant: 'COUNCIL',
  frontEndPath: 'council',
}

export const COMMUNITY_GEOGRAPHY = {
  name: 'Community District',
  constant: 'COMMUNITY',
  frontEndPath: 'community',
}

export const STATE_ASSEMBLY_GEOGRAPHY = {
  name: 'State Assembly',
  constant: 'STATE_ASSEMBLY',
  frontEndPath: 'state-assembly',
}

export const STATE_SENATE_GEOGRAPHY = {
  name: 'State Senate',
  constant: 'STATE_SENATE',
  frontEndPath: 'state-senate',
}

export const ZIPCODE_GEOGRAPHY = {
  name: 'Zip Code',
  constant: 'ZIPCODE',
  frontEndPath: 'zipcode',
  hidden: [
    '10041',
    '10043',
    '10045',
    '10055',
    '10080',
    '10081',
    '10096',
    '10097',
    '10110',
    '10112',
    '10118',
    '10119',
    '10120',
    '10121',
    '10122',
    '10123',
    '10104',
    '10105',
    '10106',
    '10107',
    '10111',
    '10151',
    '10152',
    '10153',
    '10154',
    '10155',
    '10158',
    '10162',
    '10165',
    '10166',
    '10167',
    '10168',
    '10169',
    '10170',
    '10171',
    '10172',
    '10173',
    '10174',
    '10175',
    '10176',
    '10177',
    '10178',
    '10196',
    '10203',
    '10259',
    '10260',
    '10265',
    '10270',
    '10271',
    '10275',
    '10278',
    '10279',
    '10285',
    '10286',
  ],
}
